import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface IReleaseVersion {
  version: string;
}

@Injectable()
export class ReleaseService {
  private readonly http = inject(HttpClient);

  getVersion() {
    return this.http.get<IReleaseVersion>('release/version');
  }
}
